import { render, staticRenderFns } from "./AppModalBtn.vue?vue&type=template&id=271a4b95"
import script from "./AppModalBtn.vue?vue&type=script&lang=ts"
export * from "./AppModalBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports